/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosInstance, AxiosResponse } from "axios";

//Function to get datacenter list data
export function fetchDataCenterList(
  api: AxiosInstance,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get(`/kontroledge/datacenter-interconnect?tenantId=${tenantId}&includeChildServices=true`, {});
}

//Function to fetch the performance for the bandwidth chart with datacenter id
export function fetchDatacenterPerformanceAPI(
  api: AxiosInstance,
  datacenterId: string,
  timeRange: string | undefined,
  interval: string,
  tenantId: number,
  startDate?: string,  // ISO string
  endDate?: string,    // ISO string
  maxPoints?: number
): Promise<AxiosResponse> {
  const params: Record<string, unknown> = { interval, includeLatency: true };
  
  // Use custom date range if provided, otherwise use timeRange preset
  if (startDate && endDate) {
    params.start = startDate;
    params.end = endDate;
    if (maxPoints) params.maxPoints = maxPoints;
  } else if (timeRange) {
    params.timeRange = timeRange;
  }
  
  return api.get(
    `/kontroledge/datacenter-interconnect/${datacenterId}/performance?tenantId=${tenantId}`, {
      params,
    });
}

//Function to fetch the datacenter details
export function fetchDatacenterDetailAPI(
  api: AxiosInstance,
  datacenterId: string,
  tenantId: number,
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/datacenter-interconnect/${datacenterId}?tenantId=${tenantId}`
  );
}

//Function to fetch the subscription data by datacenter id
export function fetchDatacenterSubscriptionAPI(
  api: AxiosInstance,
  datacenterId: string,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/datacenter-interconnect/${datacenterId}/subscription?tenantId=${tenantId}`
  );
}

//Function to get CRC Errors
export function fetchDatacenterErrorsAPI(
    api: AxiosInstance,
    datacenterId: string,
    tenantId: number
  ): Promise<AxiosResponse> {
    return api.get(`/kontroledge/datacenter-interconnect/${datacenterId}/crc-errors?tenantId=${tenantId}`);
  }

